var path = 'src/app/patients/fetal-ultrasounds/fetal-ultrasounds.html';
var html = "<h1 class=page-header>Fetal Ultrasounds</h1> <div fetal-ultrasounds-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/fetal-ultrasounds/fetal-ultrasounds.html
 ** module id = 457
 ** module chunks = 0
 **/